import { borderRadius } from '@mui/system'
import { createStyles, StylesClasses } from '@utils/styles'

const styles = createStyles({
  relativeWrapper: {
    position: 'relative',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '24px',
    width: '100%',
    zIndex: 1,
  },

  infoWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    width: '100%',
  },
  image: {
    height: '320px',
    width: '100%',
    borderRadius: '16px',
  },
  button: {
    // minWidth: { xs: '100%', md: '195px' },
    whiteSpace: 'nowrap',
    typography: 'body1.500',
    padding: '12px !important',
    height: '48px',
    paddingLeft: '1rem !important',
  },
  descBtnWrapper: {
    display: 'flex',
    flexDirection: {
      xs: 'column',
      md: 'row',
    },
    justifyContent: 'space-between',
    gap: {
      xs: '20px',
      md: '200px',
    },
  },
  chipsWrapper: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
  },
  chips: {
    height: '28px',
    padding: '6px',
    fontSize: '14px',
    cursor: 'default',
    backgroundColor: 'background.paper',
    gap: '4px',
  },
  description: {},
  cardsWrapper: {
    marginInline: '12px',
  },
  sectionHeaderInfoWrapper: {
    width: {
      xs: '100% !important',
      md: '80% !important',
    },
  },
  sectionHeaderDesc: {
    color: 'common.white',
  },
  heading: {},
  chip: {
    alignSelf: 'center',
    marginTop: {
      xs: '-1rem',
      sm: '0px',
    },
  },
  cardWrapper: {
    // backgroundColor: 'common.white',
    // minHeight: '480px',
    // maxWidth: '400px',
    // padding: '1.25rem',
    // borderRadius: '1rem',
    // border: '1px solid',
    // borderColor: 'border.light',
    // boxShadow: 3,
    marginInline: '12px',
  },
  chipStyled: {
    borderRadius: '20px',
    maxWidth: 'fit-content',
    padding: '4px 2px !important',
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
